import axios from '@/plugins/axios'

const state = {
    customers: {
        data: {},
        dateStart: '',
        dateEnd: '',
    },
}

const getters = {
    data: state => state.customers.data,
    dateStart: state => state.customers.dateStart,
    dateEnd: state => state.customers.dateEnd,
}

const actions = {
    setData({ commit }, data) {
        commit('SET_DATA', data)
    },
    setDateStart({ commit }, dateStart) {
        commit('SET_DATE_START', dateStart)
    },
    setDateEnd({ commit }, dateEnd) {
        commit('SET_DATE_END', dateEnd)
    },

    async requestData({ commit }, data) {
        let res = await axios
            .get('dashboard/customers', {
                params: {
                    date_start: data.dateStart,
                    date_end: data.dateEnd,
                },
            })
            .catch(err => {
                return err
            })

        if (!res) return

        commit('SET_DATA', res.data)
    },
}

const mutations = {
    SET_DATA(state, data) {
        state.customers.data = data
    },
    SET_DATE_START(state, dateStart) {
        state.customers.dateStart = dateStart
    },
    SET_DATE_END(state, dateEnd) {
        state.customers.dateEnd = dateEnd
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
